import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'henssler_at_home';
// const firebaseConfig = {
// 	kaisin: {
// 		apiKey: 'AIzaSyCCe20WPZ99icLGoleDNDxUmM7Bc4d6UwA',
// 		authDomain: 'kaisin-web-app.firebaseapp.com',
// 		projectId: 'kaisin-web-app',
// 		storageBucket: 'kaisin-web-app.firebasestorage.app',
// 		messagingSenderId: '223100500759',
// 		appId: '1:223100500759:web:963971b5b258d727015552',
// 		measurementId: 'G-6Q76ENYVP3',
// 	},
// };
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyDAdrZ5vG1_A-5rChcnhh6UQjfhX1OI9QE',
	SUPPORT_EMAIL: 'henssler@smoothr.de',
	// firebaseConfig: firebaseConfig[customerGroup],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	...apiEnvironment,
	countryList: ['de'],
	gaId: '',
	facebookPixelId: '268622425330452',
	hasRecommendations: true,
	apiUrl: 'https://dean-and-david.smoothr.de/',
	location: '',
	deactivateDelivery: false,
	enableCashPayment: false,
	allowNavigationToWorldline: false,
	urlQrCode: 'smoothr://',
	defVenue: '69d3869f5abf3b980ad9204e',
};
